import React from "react";
import LHSSection from "./LHSSection";
import RHSSection from "./RHSSection";
import { Wrapper, Container, InnerWrapper } from "./style";

export const AppInnerContent = ({
  isDark = false,
  title,
  appLinks,
  width,
  mobileLink,
  bannerRef,
}: any) => (
  <InnerWrapper isDark={isDark} ref={bannerRef}>
    <LHSSection isDark={isDark} title={title} />
    <RHSSection appLinks={appLinks} width={width} mobileLink={mobileLink} />
  </InnerWrapper>
);
function AppBanner({
  isDark = false,
  isStickyHeader = false,
  title,
  appLinks,
  bannerRef,
  width,
  mobileLink,
}: any) {
  return (
    <Wrapper isDark={isDark} isStickyHeader={isStickyHeader} ref={bannerRef}>
      <Container>
        <AppInnerContent
          isDark={isDark}
          title={title}
          appLinks={appLinks}
          width={width}
          mobileLink={mobileLink}
        />
      </Container>
    </Wrapper>
  );
}

export default AppBanner;
